module.exports = __webpack_public_path__ + "img/work-num-bg.804e10c2.png";